var _g, _path, _rect, _rect2, _g2, _path2, _ellipse, _rect3, _rect4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorConnection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 346,
    height: 170,
    viewBox: "0 0 346 170",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.15503 83.2107L56.6078 4.7677L111.187 43.9892V110.316H47.0402L7.15503 83.2107Z",
    fill: "url(#paint0_linear_6574_47756)",
    fillOpacity: 0.03,
    style: {
      mixBlendMode: "multiply"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6574_47756)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 55.1066,
    height: 80.4095,
    rx: 10,
    fill: "#F0EEEE"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.0214 25.7985C19.5361 25.7985 17.5214 27.8132 17.5214 30.2985V31.7638C14.8314 34.8081 13.1992 38.807 13.1992 43.1867C13.1992 47.5664 14.8314 51.5653 17.5214 54.6096V56.0749C17.5214 58.5602 19.5361 60.5749 22.0214 60.5749H39.4942C41.9794 60.5749 43.9942 58.5602 43.9942 56.0749V53.9673C46.3607 51.0128 47.7759 47.2648 47.7759 43.1867C47.7759 39.1086 46.3607 35.3606 43.9942 32.406V30.2985C43.9942 27.8132 41.9794 25.7985 39.4942 25.7985H22.0214Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 24.0701,
    y: 36.459,
    width: 3.78183,
    height: 13.4915,
    rx: 1.89091,
    fill: "#302C48"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 33.2546,
    y: 36.459,
    width: 3.78183,
    height: 13.4915,
    rx: 1.89091,
    fill: "#302C48"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 115.986,
    cy: 64.0042,
    rx: 14.999,
    ry: 2.69981,
    transform: "rotate(-1 115.986 64.0042)",
    fill: "url(#paint1_linear_6574_47756)",
    fillOpacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    }
  }), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_6574_47756)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M134.205 51.0216C134.205 51.0216 149.786 60.3979 182 65.5C214.214 70.6021 257.15 74.4952 238.5 91.5C221.5 107 166.238 104.5 172 128C177.762 151.5 320.035 128.651 331 159.5",
    stroke: "#6F6C85",
    strokeWidth: 8
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.287 56.2175C129.803 61.497 125.009 64.7802 120.118 64.0056C113.836 63.0106 109.774 55.6977 111.045 47.6718C112.316 39.6458 118.44 33.9461 124.722 34.9411C129.449 35.6898 132.919 40.016 133.805 45.5314L136.696 46.7965C136.696 46.7965 137.49 49.3619 137.147 51.5238C136.805 53.6857 135.295 55.6456 135.295 55.6456L132.287 56.2175Z",
    fill: "#FF5000"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 111.344,
    cy: 47.7045,
    rx: 6.29956,
    ry: 14.699,
    transform: "rotate(9 111.344 47.7045)",
    fill: "#D08009"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 97.3125,
    y: 38.4966,
    width: 16.7988,
    height: 4.19971,
    rx: 2.09985,
    transform: "rotate(9 97.3125 38.4966)",
    fill: "#E4E3E3"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 95.8108,
    y: 47.9778,
    width: 16.7988,
    height: 4.19971,
    rx: 2.09985,
    transform: "rotate(9 95.8108 47.9778)",
    fill: "#E4E3E3"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6574_47756",
    x: 0,
    y: 0,
    width: 69.1067,
    height: 94.4094,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.170007 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6574_47756"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6574_47756",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_6574_47756",
    x: 132.145,
    y: 47.59,
    width: 211.625,
    height: 122.25,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 9,
    dy: 9
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6574_47756"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6574_47756",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6574_47756",
    x1: 104.737,
    y1: 52.5077,
    x2: 39.9777,
    y2: 13.1151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6574_47756",
    x1: 99.1028,
    y1: 66.6177,
    x2: 128.142,
    y2: 66.6177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorConnection);
export default __webpack_public_path__ + "static/media/errorConnection.61d2101663a1ee7f0488b26538d84a26.svg";
export { ForwardRef as ReactComponent };